import React, { useState, useCallback, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import { wrap } from 'popmotion';
import { useDimensions } from 'hooks/useDimension';
import { slides, mobileSlides } from './image-data';
import * as S from './styles';

const variants = {
  enter: (direction: number) => {
    return {
      x: direction > 0 ? '100vw' : '-100vw',
      scale: 1,
      skew: direction > 0 ? '-20deg' : '20deg',
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    scale: 1,
    skew: '0deg',
    opacity: 1,
  },
  exit: (direction: number) => {
    return {
      zIndex: 0,
      x: direction < 0 ? '100vw' : '-100vw',
      opacity: 0,
    };
  },
};

const swipeConfidenceThreshold = 10000;
const swipePower = (offset: number, velocity: number) => {
  return Math.abs(offset) * velocity;
};

const Main: React.FC = () => {
  const { width } = useDimensions();
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [[page, direction], setPage] = useState([0, 0]);

  const indexSlide = isMobile
    ? wrap(0, mobileSlides.length, page)
    : wrap(0, slides.length, page);

  const paginate = (newDirection: number) => {
    setPage([page + newDirection, newDirection]);
  };

  const checkWidth = useCallback((): void => {
    setIsMobile(width <= 1000);
  }, [width]);

  useEffect(() => {
    checkWidth();
  }, [checkWidth]);

  return (
    <S.Container>
      <AnimatePresence initial={false} custom={direction}>
        <S.Slide
          key={page}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            x: { type: 'spring', stiffness: 300, damping: 30 },
            opacity: { duration: 0.2 },
          }}
          drag="x"
          dragConstraints={{ left: 0, right: 0 }}
          dragElastic={0}
          // onDragEnd={(e, { offset, velocity }) => {
          //   const swipe = swipePower(offset.x, velocity.x);

          //   if (swipe < -swipeConfidenceThreshold) {
          //     paginate(1);
          //   } else if (swipe > swipeConfidenceThreshold) {
          //     paginate(-1);
          //   }
          // }}
        >
          {isMobile
            ? mobileSlides[indexSlide].component
            : slides[indexSlide].component}
        </S.Slide>
      </AnimatePresence>
      <S.ButtonPrev onClick={() => paginate(-1)}>
        <S.IconLeft
          slide={isMobile ? mobileSlides[indexSlide].id : slides[indexSlide].id}
          ismobile={isMobile}
        />
      </S.ButtonPrev>
      <S.ButtonNext onClick={() => paginate(1)}>
        <S.IconRight
          slide={isMobile ? mobileSlides[indexSlide].id : slides[indexSlide].id}
          ismobile={isMobile}
        />
      </S.ButtonNext>
    </S.Container>
  );
};

export default Main;
